var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("stepheader", { attrs: { step: _vm.step } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "body current",
          attrs: {
            id: "wizard2-p-0",
            role: "tabpanel",
            "aria-labelledby": "wizard2-h-0",
            "aria-hidden": "false",
          },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "telefono" } },
                [_vm._v("Nome:")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.entity.nome,
                    expression: "entity.nome",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "telefono" },
                domProps: { value: _vm.entity.nome },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.entity, "nome", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "telefono" } },
                [_vm._v("Cognome:")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.entity.cognome,
                    expression: "entity.cognome",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "telefono" },
                domProps: { value: _vm.entity.cognome },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.entity, "cognome", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "telefono" } },
                [_vm._v("Telefono:")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.entity.telefono,
                    expression: "entity.telefono",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "telefono" },
                domProps: { value: _vm.entity.telefono },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.entity, "telefono", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "email" } },
                [_vm._v("Email:")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.entity.email,
                    expression: "entity.email",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "email" },
                domProps: { value: _vm.entity.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.entity, "email", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "marca" } },
                [_vm._v("Marca Device:")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.entity.marca,
                    expression: "entity.marca",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "marca" },
                domProps: { value: _vm.entity.marca },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.entity, "marca", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "marca" } },
                [_vm._v("Modello:")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.entity.modello,
                    expression: "entity.modello",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "marca" },
                domProps: { value: _vm.entity.modello },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.entity, "modello", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "memoria" } },
                [_vm._v("Memoria:")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.entity.memoria,
                    expression: "entity.memoria",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "memoria" },
                domProps: { value: _vm.entity.memoria },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.entity, "memoria", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "colore" } },
                [_vm._v("Colore:")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.entity.colore,
                    expression: "entity.colore",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "colore" },
                domProps: { value: _vm.entity.colore },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.entity, "colore", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "colore" } },
                [_vm._v("Messaggio:")]
              ),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.entity.messaggio,
                    expression: "entity.messaggio",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "messaggio" },
                domProps: { value: _vm.entity.messaggio },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.entity, "messaggio", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("buttons", {
            attrs: { buttons: _vm.step.buttons },
            on: { action: _vm.fireaction },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }